// UCLA's undergraduate majors (#2596, founder 2026-09-30: "majors offered by
// the college in the public page"). Read on 2026-09-30 from the official UCLA
// General Catalog 2026-27 (catalog.registrar.ucla.edu), one page per college or
// school: every Majors entry with a bachelor's degree (BA, BS, BM) in its title;
// graduate majors and minors left out. The panel pages 10 at a time, so the full
// list came from the call the page itself makes. Two entries the catalog lists
// twice appear once. Rates reuse the college file's admit rates by school
// (`classProfile`); flags quote UCLA's Supplemental Applications page
// (`programs`). The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "university-of-california-los-angeles",
    "read": "2026-09-30",
    "intro": "Every undergraduate major in UCLA's official General Catalog, grouped by the College or school that offers it, with the degree it leads to. Minors and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Letters and Science",
            "source": {
                "label": "UCLA General Catalog 2026-27, College of Letters and Science, Majors",
                "url": "https://catalog.registrar.ucla.edu/browse/College%20and%20Schools/CollegeofLettersandScience"
            },
            "rate": {
                "text": "Fall 2025 first-year admit rate for The College (Letters and Science): 11% (10,788 admitted of 98,459 applicants).",
                "source": "classProfile"
            },
            "note": "UCLA says that in the College of Letters and Science your choice of major neither helps nor hurts your application.",
            "noteSource": "classProfile",
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": "BA"
                },
                {
                    "name": "African and Middle Eastern Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Indian Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Literature and Culture",
                    "degree": "BA"
                },
                {
                    "name": "Ancient Near East and Egyptology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Applied Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Arabic",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Asian American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Asian Humanities",
                    "degree": "BA"
                },
                {
                    "name": "Asian Languages and Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Asian Religions",
                    "degree": "BA"
                },
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Astrophysics",
                    "degree": "BS"
                },
                {
                    "name": "Atmospheric and Oceanic Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Atmospheric and Oceanic Sciences/Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biophysics",
                    "degree": "BS"
                },
                {
                    "name": "Business Economics",
                    "degree": "BA"
                },
                {
                    "name": "Central and East European Languages and Cultures",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry/Materials Science",
                    "degree": "BS"
                },
                {
                    "name": "Chicana/o and Central American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Chinese",
                    "degree": "BA"
                },
                {
                    "name": "Classical Civilization",
                    "degree": "BA"
                },
                {
                    "name": "Climate Science",
                    "degree": "BS"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BS"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Literature",
                    "degree": "BA"
                },
                {
                    "name": "Computational Biology",
                    "degree": "BS"
                },
                {
                    "name": "Data Theory",
                    "degree": "BS"
                },
                {
                    "name": "Digital Humanities",
                    "degree": "BA"
                },
                {
                    "name": "Disability Studies",
                    "degree": "BA"
                },
                {
                    "name": "Earth and Environmental Science",
                    "degree": "BA"
                },
                {
                    "name": "Ecology, Behavior, and Evolution",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Engineering Geology",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "European Languages and Transcultural Studies",
                    "degree": "BA"
                },
                {
                    "name": "European Languages and Transcultural Studies with French and Francophone",
                    "degree": "BA"
                },
                {
                    "name": "European Languages and Transcultural Studies with German",
                    "degree": "BA"
                },
                {
                    "name": "European Languages and Transcultural Studies with Italian",
                    "degree": "BA"
                },
                {
                    "name": "European Languages and Transcultural Studies with Scandinavian",
                    "degree": "BA"
                },
                {
                    "name": "European Studies",
                    "degree": "BA"
                },
                {
                    "name": "Financial Actuarial Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Gender Studies",
                    "degree": "BA"
                },
                {
                    "name": "General Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geography/Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "Geophysics",
                    "degree": "BS"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "Greek",
                    "degree": "BA"
                },
                {
                    "name": "Greek and Latin",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Human Biology and Society",
                    "degree": "BA"
                },
                {
                    "name": "Human Biology and Society",
                    "degree": "BS"
                },
                {
                    "name": "Individual Field of Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Individual Field of Concentration",
                    "degree": "BS"
                },
                {
                    "name": "International Development Studies",
                    "degree": "BA"
                },
                {
                    "name": "Iranian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Japanese",
                    "degree": "BA"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Korean",
                    "degree": "BA"
                },
                {
                    "name": "Labor Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latin",
                    "degree": "BA"
                },
                {
                    "name": "Latin American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics and Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics and Asian Languages and Cultures",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics and Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics and English",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics and Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics and Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics and Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Marine Biology",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics for Teaching",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics of Computation",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics/Applied Science",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics/Economics",
                    "degree": "BS"
                },
                {
                    "name": "Microbiology, Immunology, and Molecular Genetics",
                    "degree": "BS"
                },
                {
                    "name": "Middle Eastern Studies",
                    "degree": "BA"
                },
                {
                    "name": "Molecular, Cell, and Developmental Biology",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Nordic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physiological Science",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Portuguese and Brazilian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Psychobiology",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Russian Language and Literature",
                    "degree": "BA"
                },
                {
                    "name": "Russian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Southeast Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Spanish and Community and Culture",
                    "degree": "BA"
                },
                {
                    "name": "Spanish and Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Spanish and Portuguese",
                    "degree": "BA"
                },
                {
                    "name": "Statistics and Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Study of Religion",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Henry Samueli School of Engineering and Applied Science",
            "source": {
                "label": "UCLA General Catalog 2026-27, Henry Samueli School of Engineering and Applied Science, Majors",
                "url": "https://catalog.registrar.ucla.edu/browse/College%20and%20Schools/HenrySamueliSchoolofEngineeringandAppliedScience"
            },
            "rate": {
                "text": "Fall 2025 first-year admit rate for Samueli School of Engineering: 6.8% (2,241 admitted of 33,052 applicants).",
                "source": "classProfile"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Bioengineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Materials Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of the Arts and Architecture",
            "source": {
                "label": "UCLA General Catalog 2026-27, School of the Arts and Architecture, Majors",
                "url": "https://catalog.registrar.ucla.edu/browse/College%20and%20Schools/SchooloftheArtsandArchitecture"
            },
            "rate": {
                "text": "Fall 2025 first-year admit rate for School of the Arts and Architecture: 5.1% (177 admitted of 3,437 applicants).",
                "source": "classProfile"
            },
            "majors": [
                {
                    "name": "Architectural Studies",
                    "degree": "BA",
                    "flag": "A supplemental application goes to the department, due January 20, 2027.",
                    "flagSource": "programs"
                },
                {
                    "name": "Art",
                    "degree": "BA",
                    "flag": "A supplemental application goes to the department, due January 20, 2027.",
                    "flagSource": "programs"
                },
                {
                    "name": "Computational Art",
                    "degree": "BA",
                    "flag": "A supplemental application goes to the department, due December 15, 2026.",
                    "flagSource": "programs"
                },
                {
                    "name": "Dance",
                    "degree": "BA",
                    "flag": "A supplemental application goes to the department, due December 15, 2026.",
                    "flagSource": "programs"
                },
                {
                    "name": "Design",
                    "degree": "BA"
                },
                {
                    "name": "Design|Media Arts",
                    "degree": "BA",
                    "flag": "A supplemental application goes to the department, due December 15, 2026.",
                    "flagSource": "programs"
                },
                {
                    "name": "Games",
                    "degree": "BA",
                    "flag": "A supplemental application goes to the department, due December 15, 2026.",
                    "flagSource": "programs"
                },
                {
                    "name": "Individual Field of Concentration",
                    "degree": "BA"
                },
                {
                    "name": "World Arts and Cultures",
                    "degree": "BA",
                    "flag": "A supplemental application goes to the department, due December 15, 2026.",
                    "flagSource": "programs"
                }
            ]
        },
        {
            "name": "Herb Alpert School of Music",
            "source": {
                "label": "UCLA General Catalog 2026-27, Herb Alpert School of Music, Majors",
                "url": "https://catalog.registrar.ucla.edu/browse/College%20and%20Schools/HerbAlpertSchoolofMusic"
            },
            "rate": {
                "text": "Fall 2025 first-year admit rate for Herb Alpert School of Music: 24% (282 admitted of 1,175 applicants).",
                "source": "classProfile"
            },
            "majors": [
                {
                    "name": "Ethnomusicology",
                    "degree": "BA",
                    "flag": "A supplemental application goes to the department, due December 4, 2026.",
                    "flagSource": "programs"
                },
                {
                    "name": "Global Jazz Studies",
                    "degree": "BA",
                    "flag": "A supplemental application goes to the department, due December 4, 2026.",
                    "flagSource": "programs"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music Composition",
                    "degree": "BA",
                    "flag": "A supplemental application goes to the department, due December 4, 2026.",
                    "flagSource": "programs"
                },
                {
                    "name": "Music Education",
                    "degree": "BA",
                    "flag": "A supplemental application goes to the department, due December 4, 2026.",
                    "flagSource": "programs"
                },
                {
                    "name": "Music History and Industry",
                    "degree": "BA"
                },
                {
                    "name": "Music Industry",
                    "degree": "BA",
                    "flag": "A supplemental application goes to the department, due December 4, 2026.",
                    "flagSource": "programs"
                },
                {
                    "name": "Music Performance",
                    "degree": "BM",
                    "flag": "A supplemental application goes to the department, due December 4, 2026.",
                    "flagSource": "programs"
                },
                {
                    "name": "Musicology",
                    "degree": "BA",
                    "flag": "A supplemental application goes to the department, due December 4, 2026.",
                    "flagSource": "programs"
                }
            ]
        },
        {
            "name": "School of Theater, Film, and Television",
            "source": {
                "label": "UCLA General Catalog 2026-27, School of Theater, Film, and Television, Majors",
                "url": "https://catalog.registrar.ucla.edu/browse/College%20and%20Schools/SchoolofTheaterFilmandTelevision"
            },
            "rate": {
                "text": "Fall 2025 first-year admit rate for School of Theater, Film and Television: 4.3% (140 admitted of 3,293 applicants).",
                "source": "classProfile"
            },
            "majors": [
                {
                    "name": "Film and Television",
                    "degree": "BA",
                    "flag": "A supplemental application goes to the department, due December 7, 2026.",
                    "flagSource": "programs"
                },
                {
                    "name": "Individual Field of Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Theater",
                    "degree": "BA",
                    "flag": "A supplemental application goes to the department, due December 7, 2026.",
                    "flagSource": "programs"
                }
            ]
        },
        {
            "name": "Joe C. Wen School of Nursing",
            "source": {
                "label": "UCLA General Catalog 2026-27, Joe C. Wen School of Nursing, Majors",
                "url": "https://catalog.registrar.ucla.edu/browse/College%20and%20Schools/JoeCWenSchoolofNursing"
            },
            "rate": {
                "text": "Fall 2025 first-year admit rate for School of Nursing: 0.5% (31 admitted of 5,669 applicants).",
                "source": "classProfile"
            },
            "majors": [
                {
                    "name": "Nursing Prelicensure",
                    "degree": "BS",
                    "flag": "A supplemental application goes to the department, due January 15, 2027.",
                    "flagSource": "programs"
                }
            ]
        },
        {
            "name": "School of Education and Information Studies",
            "source": {
                "label": "UCLA General Catalog 2026-27, School of Education and Information Studies, Majors",
                "url": "https://catalog.registrar.ucla.edu/browse/College%20and%20Schools/SchoolofEducationandInformationStudies"
            },
            "majors": [
                {
                    "name": "Education and Social Transformation",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Meyer and Renee Luskin School of Public Affairs",
            "source": {
                "label": "UCLA General Catalog 2026-27, Meyer and Renee Luskin School of Public Affairs, Majors",
                "url": "https://catalog.registrar.ucla.edu/browse/College%20and%20Schools/MeyerandReneeLuskinSchoolofPublicAffairs"
            },
            "majors": [
                {
                    "name": "Public Affairs",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Jonathan and Karin Fielding School of Public Health",
            "source": {
                "label": "UCLA General Catalog 2026-27, Jonathan and Karin Fielding School of Public Health, Majors",
                "url": "https://catalog.registrar.ucla.edu/browse/College%20and%20Schools/JonathanandKarinFieldingSchoolofPublicHealth"
            },
            "majors": [
                {
                    "name": "Public Health",
                    "degree": "BA"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
